var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 6.11145L7.22208 10.5559C6.60843 11.1695 6.60843 12.1645 7.22208 12.7781C7.83573 13.3918 8.83065 13.3918 9.4443 12.7781L13.8887 8.33367C15.116 7.10637 15.116 5.11652 13.8887 3.88923C12.6614 2.66192 10.6716 2.66192 9.4443 3.88923L4.99985 8.33367C3.1589 10.1746 3.1589 13.1594 4.99985 15.0003C6.8408 16.8413 9.82557 16.8413 11.6665 15.0003L16.111 10.5559",
    stroke: "#5A5F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrep);
export default __webpack_public_path__ + "static/media/Screp.c4a625b353acb6c1e4856bd3aa02c2e5.svg";
export { ForwardRef as ReactComponent };